import { Box, Typography, styled, useTheme } from "@mui/material";

const QuoteContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%', // Make it responsive width
  maxWidth: theme.spacing(40), // Keep a maximum width,
  marginTop:"40px"
}));

const QuoteTitle = styled(Typography)(({ theme }) => ({
  variant: 'h6', // Adjust variant for better mobile readability
  color: theme.palette.grey[800],
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(2), // Reduce margin for smaller screens
}));

const QuoteText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  fontSize: theme.typography.fontSize * 0.9, // Slightly smaller font size on mobile
  marginBottom: theme.spacing(2), // Reduce margin for smaller screens
}));

const QuoteLink = styled('a')(({ theme }) => ({
  color: theme.palette.grey[800],
  fontSize: theme.typography.fontSize * 0.9, // Slightly smaller font size on mobile
  textDecoration: 'underline',
  fontWeight: theme.typography.fontWeightSemiBold,
  marginBottom: theme.spacing(2), // Reduce margin for smaller screens
  '&:hover': {
    // Add hover styles if needed
  },
}));

const DailyQuote = () => {
  return (
    <QuoteContainer>
      <QuoteTitle>
        Your daily health quote
      </QuoteTitle>
      <QuoteText>
        Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.
      </QuoteText>
      <QuoteLink href="#">
        View your health goal progress &gt;
      </QuoteLink>
    </QuoteContainer>
  );
};

export default DailyQuote;